import React, { useEffect, useState } from 'react';

import styles from './MerchantProfil.module.css';

const Banner = ({ bannerUrl }) => {
    const [validFile, setvalidFile] = useState(true);
    
    useEffect(() => {
        if (!bannerUrl) {
            setvalidFile(false);
        } else {
            const img = new Image();
            img.src = bannerUrl;
            img.onload = () => setvalidFile(true);
            img.onerror = () => setvalidFile(false);
        }
    }, [bannerUrl])
    
    return (
        <div className={styles.banner} style={{ backgroundImage: `url(${!validFile ? '/TraderCard/defaultBanner.jpg' : bannerUrl})` }} />
    );
};

export default Banner;